<div class="mt-8 mb-8 flex flex-column justify-content-center">
    <div class="flex">
        <div class="xl:col-2 lg:col-2 col-12">
            <label>Gebruikersnaam</label>
        </div>
        <div class="xl:col-2 lg:col-2 col-12">
            <input pInputText type="text" placeholder="Gebruikersnaam" [(ngModel)]="userName" />
        </div>
    </div>
    <div class="flex">
        <div class="xl:col-2 lg:col-2 col-12">
            <label>Wachtwoord</label>
        </div>
        <div class="xl:col-2 lg:col-2 col-12">
            <p-password [fluid]="true" type="password" placeholder="Wachtwoord"  [toggleMask]="true" [(ngModel)]="password" />
        </div>
    </div>
    <div class="flex">
        <div class="xl:col-2 lg:col-2 col-12">
        </div>
        <div class="xl:col-2 lg:col-2 col-12">
            <p-button class="float-right" label="Inloggen" icon="pi pi-sign-in" (click)="login()" [disabled]="!userName || !password"></p-button>
        </div>
    </div>
    <div class="flex">
        <p-card class="danger" *ngIf="showError">
            <div class="row">
                <div class="xl:col-1 lg:col-1 col-12">
                    <span class="text-8xl pi pi-exclamation-triangle"></span>
                </div>
                <div class="xl:col-11 lg:col-11 col-12">
                    <h3>Foutmelding</h3>
                    <p>{{ errorMessage }}</p>
                </div>
            </div>
        </p-card>
    </div>
</div>